"use strict";
import * as fabric from "fabric";
window.APP = window.APP || {};
const config = {
  defaultCountry: "co",
  imageurl: "https://labelcustomizer.customizelabel.app/",
  environments: {
    production: {
      backurl: "https://labelcustomizer.customizelabel.app/backend/api/",
      imageurl: "https://labelcustomizer.customizelabel.app/",
    },
    staging: {
      backurl: "https://api-ch.customizelabel.app/backend/api/",
      imageurl: "https://api-ch.customizelabel.app/",
    },
    development: {
      backurl: "http://192.168.131.234:84/backend/api/",
      imageurl: "https://labelcustomizer.customizelabel.app",
    },
  },
};
let currentEnv = "production";
const hostname = location.hostname;
if (hostname === "192.168.131.234" || hostname === "localhost") {
  currentEnv = "development";
} else if (hostname === "ch.customizelabel.app") {
  currentEnv = "staging";
}
window.backurl = config.environments[currentEnv].backurl;
window.imageurl = config.environments[currentEnv].imageurl;
window.country = config.defaultCountry;
APP.LCRouter = Backbone.Router.extend({
  routes: {
    "": "languageSelection",
    inicio: "index",
    activation: "activation",
    "activation/force": "forceActivation",
    languageselection: "languageSelection",
    brandselection: "brandSelection",
    labelconfirmation: "labelConfirmation",
    labelcustomization: "labelCustomization",
    labelpreview: "labelPreview",
    registration: "registration",
    labelprint: "labelPrint",
  },

  initialize: function () {
    this.$container = $(".app-container");
    this.collection = new APP.Collection();
    this.collection.fetch({ ajaxSync: false });
    // Crear window.data siempre al inicializar
    window.data = new APP.Model();
    window.data.set("country", window.country);
    
    this.$container.on("click", ".screen--start", (e) => {
      e.preventDefault();
      this.navigate("brandselection", { trigger: true });
    });
    
    // Iniciar Backbone history primero
    if (!Backbone.History.started) {
      Backbone.history.start();
    }
    
    // Verificar activación solo si estamos en la ruta raíz
    const currentRoute = Backbone.history.fragment;
    if (!this.isActivated() && currentRoute === "") {
      this.navigate("activation", { trigger: true, replace: true });
    }
    // Si está activado, siempre mostrar selector de idioma en la raíz
    // La navegación a 'inicio' solo ocurre después de seleccionar idioma
  },
  isActivated: function () {
    // Verificar si existen las claves 'key' y 'serial' en localStorage
    const key = localStorage.getItem("key");
    const serial = localStorage.getItem("serial");
    return key && serial;
  },
  hasLanguage: function () {
    return localStorage.getItem("language") !== null;
  },
  activation: function () {
    const view = new APP.ActivationView({});
    this.$container.html(view.render().el);
  },
  forceActivation: function () {
    // Permite acceder a la pantalla de activación aunque ya esté activado
    const view = new APP.ActivationView({});
    this.$container.html(view.render().el);
  },
  languageSelection: function () {
    // Ya no verificar activación - permitir siempre acceder a selector de idioma
    const view = new APP.LanguageSelectionView({});
    this.$container.html(view.render().el);
  },
  index: function () {
    // Verificar activación antes de mostrar cualquier pantalla
    if (!this.isActivated()) {
      this.navigate("activation", { trigger: true, replace: true });
      return;
    }
    // Verificar si el idioma está seleccionado
    if (!this.hasLanguage()) {
      this.navigate("", { trigger: true, replace: true });
      return;
    }
    const view = new APP.IndexView({});
    this.$container.html(view.render().el);
  },
  brandSelection: function () {
    // Verificar activación antes de mostrar cualquier pantalla
    if (!this.isActivated()) {
      this.navigate("activation", { trigger: true, replace: true });
      return;
    }
    const view = new APP.SelectBrandView({});
    this.$container.html(view.render().el);
    $(".screen--brand-select .brand-selector__button").on("click", (e) => {
      const brandid = $(e.currentTarget).data("brand");
      window.data.set({ brand: brandid });
      this.navigate("labelconfirmation", { trigger: true });
    });
  },
  labelConfirmation: function () {
    // Verificar activación antes de mostrar cualquier pantalla
    if (!this.isActivated()) {
      this.navigate("activation", { trigger: true, replace: true });
      return;
    }
    const brandid = window.data.get("brand");
    const view = new APP.LabelConfirmationView({ brandid: brandid });
    this.$container.html(view.render().el);
  },
  labelCustomization: function () {
    // Verificar activación antes de mostrar cualquier pantalla
    if (!this.isActivated()) {
      this.navigate("activation", { trigger: true, replace: true });
      return;
    }
    const brandid = window.data.get("brand");
    const view = new APP.LabelCustomizationView({ brandid: brandid });
    this.$container.html(view.render().el);
    const updateNextButtonVisibility = () => {
      const nameLength = $(".name-input-holder__input").val().length;
      const genderSelected = window.data.get("gender") !== "";
      if (nameLength >= 1 && genderSelected) {
        $(".screen--customization .button-container__button--next").show();
      } else {
        $(".screen--customization .button-container__button--next").hide();
      }
    };
    $('input[name="gender"]').on("click", (e) => {
      const target = $(e.currentTarget);
      if (target.is(":checked")) {
        const gender = target.val();
        window.data.set({ gender: gender });
        $(".gender-label").hide();
        $(`.gender-label--${gender}`).show();
        $('input[name="gender"]').not(target).prop("checked", false);
      } else {
        window.data.set({ gender: "" });
      }
      updateNextButtonVisibility();
    });
    $(".name-input-holder__input").on("keyup", (e) => {
      const value = $(e.currentTarget).val();
      if (value.length > 8) {
        $(".error-holder").show();
      } else {
        $(".error-holder").hide();
      }
      window.data.set({ name: value });
      updateNextButtonVisibility();
    });
  },
  labelPreview: function () {
    // Verificar activación antes de mostrar cualquier pantalla
    if (!this.isActivated()) {
      this.navigate("activation", { trigger: true, replace: true });
      return;
    }
    const { brand } = window.data.attributes;
    const view = new APP.LabelPreviewView({ brandid: brand });
    this.$container.html(view.render().el);
  },
  labelPrint: function () {
    // Verificar activación antes de mostrar cualquier pantalla
    if (!this.isActivated()) {
      this.navigate("activation", { trigger: true, replace: true });
      return;
    }
    const { brand } = window.data.attributes;
    const view = new APP.LabelPrintView({ brandid: brand });
    this.$container.html(view.render().el);
    $(".screen--print .button-container__button--skip").on("click", (e) => {
      e.preventDefault();
      this.navigate("inicio", { trigger: true });
    });

  },
  registration: function () {
    // Verificar activación antes de mostrar cualquier pantalla
    if (!this.isActivated()) {
      this.navigate("activation", { trigger: true, replace: true });
      return;
    }
    const brandid = window.data.get("brand");
    const view = new APP.RegistrationView({ brandid: brandid });
    this.$container.html(view.render().el);
    const validRegex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
    const $nameInput = $(".screen--registration .form-input--name");
    const $emailInput = $(".screen--registration .form-input--email");
    const $optinCheckbox = $(".screen--registration .form-checkbox--registration");
    const $nextButton = $(".screen--registration .button-container__button--next");
    const validateAndToggleButton = () => {
      const isNameValid = $nameInput.val().length > 0;
      const isEmailValid = $emailInput.val().length > 0 && $emailInput.val().match(validRegex);
      const isOptinChecked = $optinCheckbox.is(":checked");
      if (isNameValid && isEmailValid && isOptinChecked) {
        $nextButton.addClass("button-container__button--active");
      } else {
        $nextButton.removeClass("button-container__button--active");
      }
    };
    $(".screen--registration .form-input--name, .screen--registration .form-checkbox--registration").on("change", validateAndToggleButton);
    $(".screen--registration .form-input--email").on("keyup", validateAndToggleButton);
    $nextButton.on("click", () => {
      if ($nextButton.hasClass("button-container__button--active")) {
        window.data.set({
          user_name: $nameInput.val(),
          user_email: $emailInput.val(),
        });
        this.navigate("brandselection", { trigger: true });
      }
    });
  }
  
});
